/**
 * Created by saeed on 12/29/2016.
 */
import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {
  API_URL_GET_COMPANY_LIST_BY_PARENT_ID,
  API_URL_IMAGE_BY_IMAGE_ID,
  DEFAULT_IMAGE_DIRECTORY,
  API_URL_IMAGE_THUMB_BY_IMAGE_ID,
  API_URL_COMPANY_BY_DOMAIN,
  API_URL_COMPANY_SOCIAL_NETWOR_BY_ID,
  API_URL_COMPANY_WORKING_TIME_BY_ID,
  API_URL_COMPANY_BY_KEY_URL,
  API_URL_GET_IAMAGELIST_BY_ALBUM_ID,
  DEFAULT_SUBDOMAIN,
  API_URL_SERACH_COMPANY,
  API_URL_GET_SERVANT_BY_COMPANY_ID,
  API_URL_GET_USER_INFO_BY_ID,
  API_URL_GET_COMPANY_CUSTOM_FORM_BY_ID,
  API_URL_SAVE_COMPANY_CUSTOMER,
  API_URL_GET_COMPANY_CUSTOMER_FORM_DATA_BY_COMPANY_CUSTOM_FORM_ID,
  API_URL_SAVE_COMPANY_CUSTOM_FORM_DATA,
  API_URL_DELETE_COMPANY_CUSTOM_FORM_DATA_BY_ID,
  API_URL_GET_COMPANY_CUSTOM_FORM_DATA_BY_COMPANY_CUSTOMER_ID,
  API_URL_GET_COMPANY_CUSTOMER_BY_USER_ID_AND_COMPANY_ID,
  API_URL_GET_COMPANY_LIST_BY_MARKET_PLACE_COMPANY_ID,
  API_URL_GET_MARKET_PLACE_COMPANY_CARD_IMAGE_BY_ALBUM_ID,
  API_URL_GET_COMPANY_EMPTY_CUSTOMER_INTAKE_DATA_BY_ID,
  API_URL_GET_COMPANY_CUSTOMER_INTAKE_DATA_BY_ID,
  API_URL_GET_COMPANY_CUSTOMER_FOR_DATA_ENTRY_BY_COMPANY_ID,
  API_URL_GET_MARKET_PLACE_BY_KEY_URL,
  API_URL_GET_COMPANY_OPEN_HOURS_TO_RESERVE
} from '../constants';
import {DOCUMENT} from '@angular/platform-browser';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {CacheUtilService} from "../../services/cache-util/CacheUtilService";
import {Inject} from '@angular/core';
import {BaseHttpService} from "../base-http-service";
import {ImageVM} from "../../models/ImageVM.model";
import {Router, ActivatedRoute, Params} from '@angular/router';
import {CompanyVM} from "../../models/CompanyVM.model";
import {ServantVM} from "../../models/ServiceItemDetailVM";
import {AppConfig} from "../app.config";
import {IAppConfig} from "../../models/app-config.model";


//import {Observable} from "../../Observable";


export var currentCompany: any = new CompanyVM('-');

@Injectable()
export class CompanyService {
  private baseDomains: string[] = ['reserweb','wedomeet', 'tamin', 'appviser','planovin', 'pponline' , 'plnstage'];
  private company;
  public iframe: boolean = false;
  public setting: IAppConfig = AppConfig.settings;
  // Resolve HTTP using the constructor
  constructor(private http: BaseHttpService, private _cacheUtil: CacheUtilService, private activatedRoute: ActivatedRoute, @Inject(DOCUMENT) private document: any) {


  }

  /**
   * the subdomain part of url which is company url
   * @returns {string|any}
   */
  public inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  public isIframe(): Observable<boolean> {
    let parent = this;
    return new Observable((observer) => {

      observer.next(parent.inIframe());
      //parent.activatedRoute.queryParams.subscribe((params: Params) => {
      //
      //  let iframe = params['iframe'];
      //  if(iframe && iframe=='true'){parent.iframe= true;observer.next(parent.iframe);}
      //  else {
      //
      //    parent.iframe= false;observer.next(parent.iframe);}
      //  //observer.complete();
      //});
    });
  }

  public getBaseUrl() {

    let url = this.getUrl();
    let domain = this.extractDomain(url);
    let subdomain = this.extractSubdomainFromDomain(domain);
    return subdomain;

  }

  getUrl() {

    let url = this.document.location.href;

    if (url.indexOf("localhost") > -1)
      url = DEFAULT_SUBDOMAIN;

    if(this.setting.ui.has_static_ip && url.includes(this.setting.ui.static_ip))
      url = DEFAULT_SUBDOMAIN;


    url = url.toLowerCase();
    return url;
  }

  public getDomain() {

    let url = this.getUrl();
    let domain = this.extractDomain(url);
    var re = "www.";
    domain = domain.replace(re, "");

    return domain;

  }

  public extractDomain(url: string) {
    let domain;
    //find & remove protocol (http, ftp, etc.) and get domain
    if (url.indexOf("://") > -1) {
      domain = url.split('/')[2];
    } else {
      domain = url.split('/')[0];
    }

    //find & remove port number
    domain = domain.split(':')[0];

    return domain;
  }

  private isInBaseDomains(domain: string) {
    return (this.baseDomains.indexOf(domain.toLowerCase()) > -1);

  }

  private extractSubdomainFromDomain(domain: string): string {

    //

    let subdomain: string;
    let parts = domain.split('.');


    if (parts.length == 3) {
      if (!(parts[0].toLowerCase() == 'www'))
        if (this.isInBaseDomains(parts[1]))
          subdomain = parts[0];

    } else if (parts.length > 3) {
      let i = 0;
      if ((parts[0].toLowerCase() == 'www'))
        i = 1;
      if (this.isInBaseDomains(parts[i + 1]))
        subdomain = parts[i];
    }


    return subdomain;
  }


  public getCompanyInfo(companyKeyUrl?): Observable<any> {
    // if(AppConfig.settings)
    let keyUrl = this.getBaseUrl();
    if(companyKeyUrl)
      keyUrl = companyKeyUrl;



    if (keyUrl) {
      let currentComanyKey = keyUrl;

      if (this._cacheUtil.exists(currentComanyKey)) {

        return Observable.of(this._cacheUtil.getFromCach(currentComanyKey));
      } else {
        return this.http.get(API_URL_COMPANY_BY_KEY_URL + '?url=' + keyUrl)
          // ...and calling .json() on the response to return data
          .map((res: any) => {

            if (!res.id) {
              window.location.href = '/not-found.html?backurl=' + window.location.href;
              //  return null;
            }
            //
            currentCompany = res;
            if (currentCompany.setting && currentCompany.setting.financialSetting)
              currentCompany.inPlacePayment = currentCompany.setting.financialSetting.inPlacePayment;
            let durationViewMode = this.getCompanyCustomSetting(currentCompany, "durationViewMode");
            if (durationViewMode && durationViewMode == 'HIDE') {
              currentCompany.setting.showDuration = false;
            } else {
              currentCompany.setting.showDuration = true;
            }

            let priceViewMode = this.getCompanyCustomSetting(currentCompany, "priceViewMode");
            if (priceViewMode && priceViewMode == 'HIDE') {
              currentCompany.setting.showPrice = false;
            } else {
              currentCompany.setting.showPrice = true;
            }


            this._cacheUtil.storeTemporaryInCache(currentComanyKey, currentCompany, 1);
            return currentCompany;
          })
          //...errors if any
          .catch(
            (error: any) => {
              // window.location.href='/not-found.html?backurl='+window.location.href;
              return Observable.throw(error || 'Server error');
            }
          );
        //   }

      }

    } else {
      var domain = this.getDomain();
      if (this._cacheUtil.exists(domain)) {

        return Observable.of(this._cacheUtil.getFromCach(domain));
      } else {

        return this.http.get(API_URL_COMPANY_BY_DOMAIN + '?domain=' + domain)
          // ...and calling .json() on the response to return data
          .map((res: Response) => {
            if (!res) {
              alert("آدرس وارد شده صحیح نیست");
              //  return null;
            }
            //
            currentCompany = res;
            if (currentCompany.setting && currentCompany.setting.financialSetting)
              currentCompany.inPlacePayment = currentCompany.setting.financialSetting.inPlacePayment;

            this._cacheUtil.storeTemporaryInCache(domain, currentCompany, 1);
            return currentCompany;
          })
          //...errors if any
          .catch(
            (error: any) => {
              // window.location.href='/not-found.html?backurl='+window.location.href;
              return Observable.throw(error || 'Server error');
            }
          );
        //   }

      }

    }
  }

  public getCompanyWorkingTime(companyid): Observable<any> {

    if (companyid) {
      return this.http.get(API_URL_COMPANY_WORKING_TIME_BY_ID + companyid)
        // ...and calling .json() on the response to return data
        .map((res: Response) => {

          return res;
        })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }

  }

  public getCompanySocialNetwork(companyid): Observable<any> {

    if (companyid) {
      return this.http.get(API_URL_COMPANY_SOCIAL_NETWOR_BY_ID + companyid)
        // ...and calling .json() on the response to return data
        .map((res: Response) => {

          return res;
        })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }

  }

  public getCompanyLogoImage(company: CompanyVM): Observable<ImageVM> {
    let parent = this;
    return new Observable(function (observer) {

      if (company && company.setting && company.setting.themeSettingInfo) {
        if (company.setting.themeSettingInfo.logoImageId)
          parent.getAlbumImageList(company.setting.themeSettingInfo.logoImageId).subscribe((imageList) => {
            if (imageList.length > 0) {

              observer.next(imageList[0]);

            }
          });


      }


    });


    //if(this._cacheUtil.exists(keyUrl+'logo') )
    //  return Observable.of( this._cacheUtil.getFromCach(keyUrl+'logo'));
    //else
    //{

    // }

    //  return Observable.of(null);

  }

  public getAlbumImageList(albumid: number): Observable<ImageVM[]> {
    let imageList: any;

    // ...using get request

    return this.http.get(API_URL_GET_IAMAGELIST_BY_ALBUM_ID + '?albumid=' + albumid)
      // ...and calling .json() on the response to return data
      .map((res: Response) => {
        //;
        imageList = res;

        return imageList;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));


  }

  public searchCompanies(query: string, page: string): Observable<CompanyVM[]> {

    return this.http.get(API_URL_SERACH_COMPANY + '?query=&page=0&size=20&sort=id,asc')
      // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));


  }

  getCompanyfullWebSiteUrl(): Observable<string> {

    return Observable.of('http://' + this.getBaseUrl() + '.reserweb.ir');


  }

  getCompanyListByParent(parentId: any): Observable<any> {
    return this.http.get(API_URL_GET_COMPANY_LIST_BY_PARENT_ID + '?parentId=' + parentId)
      // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  makeImageUrl(usecase: String, coverImage: ImageVM | any, activityType: String, isthumb: boolean): any {
    if (coverImage && coverImage.id) {
      if (isthumb)
        return API_URL_IMAGE_THUMB_BY_IMAGE_ID + "?imageDataId=" + coverImage.id;
      return API_URL_IMAGE_BY_IMAGE_ID + "?imageDataId=" + coverImage.id;
    } else if (usecase && activityType) {
      return DEFAULT_IMAGE_DIRECTORY + "/" + activityType + "/" + usecase + ".jpg";
    }
    return DEFAULT_IMAGE_DIRECTORY + "/" + activityType + "/" + usecase + ".jpg";
  }

  public getMarketPlaceCompanyImageCardByAlbumId(albumId: number): Observable<ImageVM> {
    let image: any;

    return this.http.get(API_URL_GET_MARKET_PLACE_COMPANY_CARD_IMAGE_BY_ALBUM_ID + '?albumid=' + albumId)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        //;
        image = res;

        return image;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));


  }

  getCompanyCustomSetting(serviceItem: CompanyVM, key) {

    let value;
    if (serviceItem && serviceItem.customSetting) {
      var customSetting = JSON.parse(serviceItem.customSetting);
      if (customSetting[key] != undefined)
        value = customSetting[key];

    }
    return value;
  }

  getCompanyServant(companyid): Observable<any> {

    if (companyid) {
      return this.http.get(API_URL_GET_SERVANT_BY_COMPANY_ID + '/' + companyid).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getCompanyCustomFormById(companyId): Observable<any> {
    if (companyId) {
      return this.http.get(`${API_URL_GET_COMPANY_CUSTOM_FORM_BY_ID}?companyId=${companyId}`).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  saveCompanyCustomFormData(companyCustomerFormData): Observable<any> {
    if (companyCustomerFormData) {
      return this.http.post(API_URL_SAVE_COMPANY_CUSTOM_FORM_DATA, companyCustomerFormData).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  deleteCompanyCustomFormDataById(fromDataId): Observable<any> {
    if (fromDataId) {
      return this.http.delete(API_URL_DELETE_COMPANY_CUSTOM_FORM_DATA_BY_ID + '/' + fromDataId).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getCompanyCustomFormDataByFormId(formId): Observable<any> {
    if (formId) {
      return this.http.get(`${API_URL_GET_COMPANY_CUSTOMER_FORM_DATA_BY_COMPANY_CUSTOM_FORM_ID}?companyCustomFormId=${formId}`).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }
    }
  }

  getCompanyCustomFormDataByCompanyCustomerId(customerId): Observable<any> {
    if (customerId) {
      return this.http.get(`${API_URL_GET_COMPANY_CUSTOM_FORM_DATA_BY_COMPANY_CUSTOMER_ID}?companyCustomerId=${customerId}`).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }
    }
  }

  saveCompanyCustomer(CompanyCustomerObj): Observable<any> {
    if (CompanyCustomerObj) {
      return this.http.post(API_URL_SAVE_COMPANY_CUSTOMER, CompanyCustomerObj).map((res: Response) => {
        return res;
      })
        //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getCompanyListByMarketPlaceCompanyId(companyId: any): Observable<any> {
    return this.http.get(API_URL_GET_COMPANY_LIST_BY_MARKET_PLACE_COMPANY_ID + '?companyId=' + companyId)
    // ...and calling .json() on the response to return data
      .map((res: Response) => {
        return res;
      })
      //...errors if any
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  getCompanyEmptyCustomerIntakeData(companyId): Observable<any> {
    if (companyId) {
      return this.http.get(`${API_URL_GET_COMPANY_EMPTY_CUSTOMER_INTAKE_DATA_BY_ID}?companyId=${companyId}`).map((res: Response) => {
        return res;
      })
      //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getCompanyCustomerIntakeData(companyId): Observable<any> {
    if (companyId) {
      return this.http.get(`${API_URL_GET_COMPANY_CUSTOMER_INTAKE_DATA_BY_ID}?companyId=${companyId}`).map((res: Response) => {
        return res;
      })
      //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getCompanyCustomerForDataEntry(companyId): Observable<any> {
    if (companyId) {
      return this.http.get(`${API_URL_GET_COMPANY_CUSTOMER_FOR_DATA_ENTRY_BY_COMPANY_ID}?companyId=${companyId}`).map((res: Response) => {
        return res;
      })
      //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getMarketPlaceByKeyUrl(keyUrl): Observable<any> {
    if (keyUrl) {
      return this.http.get(`${API_URL_GET_MARKET_PLACE_BY_KEY_URL}?url=${keyUrl}`).map((res: Response) => {
        return res;
      })
      //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }

  getCompanyOpenHoursToReserve(companyId): Observable<any> {

    if (companyId) {
      return this.http.get(`${API_URL_GET_COMPANY_OPEN_HOURS_TO_RESERVE}?companyId=${companyId}`).map((res: Response) => {
        return res;
      })
      //...errors if any
        .catch((error: any) => Observable.throw(error || 'Server error'));
      //   }

    }
  }



}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/services/company-service/company-service.ts